export default {
  apply_submit: 'Skicka ansökan',
  apply_submitting: 'Skickar...',
  apply_cv_label: 'CV',
  apply_coverLetter_label: 'Personligt brev',
  apply_email_label: 'E-post',
  apply_name_label: 'För och efternamn',
  apply_sex_label: 'Kön',
  apply_ssn_label: 'Födelsedatum',
  apply_phone_label: 'Telefon',
  apply_successModal_title: 'Ansökan är mottagen',
  apply_successModal_text:
    'En bekräftelse har skickats till din e-post. Var god kontrollera din skräppost om du inte har fått den.',
  apply_successModal_backToJobs: 'Tillbaka till platsannonsen',
  apply_error_required: 'Obligatoriskt fält',
  apply_error_email: 'Ogiltig e-postadress',
  apply_error_ssn: 'Ogiltigt födelsedatum',
  apply_connect: 'Connecta med',
  apply_connected: 'Connectat',

  backToJobs: 'Tillbaka till platsannonser',
  backToDetail: 'Tillbaka till arbetsbeskrivningen',
  openings_singular: '{0} Ledig tjänst',
  openings_plural: '{0} Lediga tjänster',
  no_openings: 'För tillfället annonseras inga lediga tjänster',
  apply_button: 'Ansök nu',
  deadline_display: 'Sista ansökningsdatum',
  deadline_none: 'Ingen deadline',
  vacancies_singular: 'ledig tjänst',
  vacancies_plural: 'lediga tjänster',
  filter_search_placeholder: 'Sök...',
  openings_showing_singular: 'Visar {0} / {1} tjänst',
  openings_showing_plural: 'Visar {0} / {1} tjänster',
  filter_no_results_main: 'Inga tjänster matchar sökning eller filter',
  filter_no_results_sub: 'Förfina sökningen eller återställ filtren',
  clear_all: 'Rensa allt',
  select_placeholder: 'Välj...',
  upload_file: 'Ladda upp fil',
  accept_terms_body_text: 'Klicka här om du samtycker med villkoren.',
  fifty_privacy_policy: ' 50skills integritetspolicy',
  privacy_policy_and: ' och',
  company_privacy_policy: '{0} Integritetspolicy',
  terms_agreement_required: 'Det krävs att du samtycker med villkoren',
  apply_form_has_errors: 'Rätta de markerade fälten innan du skickar in',
  job_list_no_openings_main: 'Inga lediga tjänster för tillfället.',
  job_list_no_openings_sub: 'Välkommen tillbaka vid annat tillfälle!',
  job_list_no_language_data: 'För tillfället finns det ingen svensk översättning av denna annons.',
  job_list_no_language_data_sub:
    'Välj språk uppe i högra hörnet för att se annonsen på ett annat språk.',
  jobStatus_full_time: 'Heltid',
  jobStatus_part_time: 'Deltid',
  jobStatus_per_diem: 'Timlön',
  jobStatus_not_specified: 'Ej specificerat',
  en: 'English',
  is: 'Íslenska',
  pl: 'Polski',
  no: 'Norsk',
  sv: 'Svenska',
  fr: 'Français',
  languageSwitcher_title: 'Välj språk',
  'The submitted file is empty.': 'Den skickade filen är tom.',
  job_does_not_exist_header: 'Sidan du letar efter finns inte.',
  job_does_not_exist_sub_header: 'Du kan ha skrivit fel adress eller så har tjänsten tagits bort.',
  job_does_not_exist_link: 'Ta mig tillbaka till hemsidan',
  fiftyFooter_poweredBy: 'Powered by',
  jobStatus_title: 'Jobbstatus',
  cookie_consent_main_text: 'Genom att använda denna sida godkänner du våra villkor.',
  cookie_consent_privacy_cta_text: ' Villkor för cookies.',
  cookie_consent_privacy_button_text: 'Avböj',
  department_title: 'Avdelning',
  department_unspecified: 'Ej specificerat',
};
